import React from 'react';
import {
    ACTION_DOWN, ACTION_DOWN_LEFT, ACTION_DOWN_RIGHT,
    ACTION_LEFT, ACTION_RELAX, ACTION_RIGHT,
    ACTION_UP, ACTION_UP_LEFT, ACTION_UP_RIGHT,
    ACTION_CENTER
} from "../../tools/EyeActions";
import { getAvatarState } from "./avatarUtils";

const pupilOffsets = {
    [ACTION_LEFT]:       { x: -10, y: 0 },
    [ACTION_RIGHT]:      { x: 10, y: 0 },
    [ACTION_UP]:         { x: 0, y: -10 },
    [ACTION_DOWN]:       { x: 0, y: 10 },
    [ACTION_UP_LEFT]:    { x: -7, y: -7 },
    [ACTION_UP_RIGHT]:   { x: 7, y: -7 },
    [ACTION_DOWN_LEFT]:  { x: -7, y: 7 },
    [ACTION_DOWN_RIGHT]: { x: 7, y: 7 },
    [ACTION_CENTER]:     { x: 0, y: 0 },
    [ACTION_RELAX]:      { x: 0, y: 0 },
};

class ClassicAvatar extends React.Component {
    render() {
        const { offset, isRelax, containerSize, isBlink, pulseClass } = getAvatarState(this.props, pupilOffsets);

        return (
            <div className="avatar-holder" style={{ width: containerSize, height: containerSize * 0.75 }}>
                <svg viewBox="0 0 200 150" className="avatar-svg">
                    <ellipse cx="100" cy="75" rx="85" ry="65" fill="var(--avatar-primary)" fillOpacity="0.08" stroke="var(--avatar-outline)" strokeOpacity="0.15" strokeWidth="1.5" />
                    <path d="M42 62 Q68 48 94 62" fill="none" stroke="var(--avatar-outline)" strokeWidth="1.2" strokeLinecap="round" opacity="0.25" />
                    <path d="M106 62 Q132 48 158 62" fill="none" stroke="var(--avatar-outline)" strokeWidth="1.2" strokeLinecap="round" opacity="0.25" />

                    {/* Eyes */}
                    <g className={isBlink ? 'avatar-eye-blink' : ''} style={{ transformOrigin: '68px 72px' }}>
                        <ellipse cx="68" cy="72" rx="28" ry={isRelax ? 2 : 18} fill="var(--avatar-eye-white)" stroke="var(--avatar-outline)" strokeWidth="1.5" style={{ transition: 'ry 0.3s ease' }} />
                        {!isRelax && (<>
                            <circle className={pulseClass} cx={68 + offset.x} cy={72 + offset.y} r="9" fill="var(--avatar-pupil)" style={{ transition: 'cx 0.2s ease, cy 0.2s ease' }} />
                            <circle cx={68 + offset.x - 3} cy={72 + offset.y - 3.5} r="3.5" fill="var(--avatar-eye-shine)" style={{ transition: 'cx 0.2s ease, cy 0.2s ease' }} />
                        </>)}
                    </g>
                    <g className={isBlink ? 'avatar-eye-blink' : ''} style={{ transformOrigin: '132px 72px' }}>
                        <ellipse cx="132" cy="72" rx="28" ry={isRelax ? 2 : 18} fill="var(--avatar-eye-white)" stroke="var(--avatar-outline)" strokeWidth="1.5" style={{ transition: 'ry 0.3s ease' }} />
                        {!isRelax && (<>
                            <circle className={pulseClass} cx={132 + offset.x} cy={72 + offset.y} r="9" fill="var(--avatar-pupil)" style={{ transition: 'cx 0.2s ease, cy 0.2s ease' }} />
                            <circle cx={132 + offset.x - 3} cy={72 + offset.y - 3.5} r="3.5" fill="var(--avatar-eye-shine)" style={{ transition: 'cx 0.2s ease, cy 0.2s ease' }} />
                        </>)}
                    </g>
                </svg>
            </div>
        );
    }
}

export default ClassicAvatar;
